export const hasAuthAccessParams = (params) => 'access_token' in params && !!params.access_token;
export const isSuccessResponse = (response) => response.statusCode === 0;
//# sourceMappingURL=guards.js.map